<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <!-- 测试开始 -->
        <!-- <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="height: 7vh;"></div> -->

       
            <div style="height: 100vh;">
            <div class="search-bar" >
                <i @click="handleSearch" class="search-icon"><img src="../../assets/pic-24cccc.png" alt=""></i>
                <input
                        type="text"
                        v-model="searchQuery"
                        placeholder="在puchi.cn上搜索"
                        @keyup.enter="handleSearch"
                />
            </div>
            <div class="quick-links">
                <h4>快速连接</h4>
                <ul>
                    <li>售后客服</li>
                    <li>产品使用手册</li>
                    <li>线下展示中心</li>
                </ul>
            </div>

     
    </div>
       
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
   
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    export default {
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
          
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return { 
      
                searchQuery: '', // 在 data 中定义 searchQuery

                imageUrlone: require('../../assets/Instructionsimgmain.png'),
                imageUrltwo: require('../../assets/logotuteng.png'),
                isScrolled: false,
        
            };
        },

        mounted() {
     
            this.initObserver(); // 初始化观察器
    window.addEventListener('wheel', this.initObserver, { passive: false });
            // window.addEventListener('wheel', this.handleScroll, { passive: false });
            // this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

            handleSearch() {
                if (this.searchQuery) {
                    // 执行搜索逻辑
                    alert(`Searching for: ${this.searchQuery}`);
                    // 在这里添加实际的搜索逻辑，比如导航到搜索结果页或调用搜索API
                } else {
                    alert('请输入搜索内容');
                }
            },
            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>

/*  /*快速连接开始*/
.quick-links {
    /*font-family: Arial, sans-serif;*/
    /*margin: 20px;*/
    padding-left: 24rem;
    margin-top: 2rem;
}

.quick-links h4 {
    font-size: 12px;
    color: #888; /* 字体颜色变灰 */
    margin-bottom: 10px; /* 标题和列表之间的间距 */
}

.quick-links ul {
    list-style-type: none;
    padding: 0;
}

.quick-links li {
    font-weight: bold;
    font-size: 13px;
    color: #333; /* 列表项字体颜色 */
    margin-bottom: 10px; /* 列表项之间的间距 */
}

/*快速链接结束*/
/*    搜索框开始*/
.search-bar {
    display: flex;
    align-items: center;
    border-radius: 5px;
    padding: 10px;
    background-color: #e0e0e0; /* 与图片背景颜色一致 */
    max-width: 100rem;
    margin: 3rem auto 0 auto; /* 上移20px */
    width: 50rem;
}

.search-icon {
    margin-right: 10px;
    font-size: 16px;
    color: #666;
}
.search-icon img{
    width: 1.5rem;
}

.search-bar input {
    flex-grow: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 16px;
    color: #666;
}
/*搜索框结束*/



/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
    height: 100%;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: 100%;
        /* margin-bottom: 9vh; */
}

/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
